module.exports = __webpack_public_path__ + "AX.png?f8dce949b64b170512121b76b36a19a2";